<template>
    <div>
        <div class='content contentStudentMessage'>
            <BigTitle title='part.1 基本信息'></BigTitle>
            <MiddleTitle title='学生普查'></MiddleTitle>

            <div class="main" v-if="student">
                <SmallTitle title='学生基本信息'></SmallTitle>
                <ul>
                    <li>姓名：{{student.name}}</li>
                    <li>性别：{{student.sexName}}</li>
                    <li>民族：{{student.nation}}</li>
                    <li>生日：{{this.switchTimeFormat(student.birth)}}</li>
                    <li style="width: 66%">籍贯：{{student.hometown}}</li>
                    <li>学校：{{student.school}}</li>
                    <li>班级：{{student.class}}</li>
                    <li>班级职务：{{student.classPosition}}</li>
                    <li>高考科类：{{student.subject}}</li>
                </ul>
            </div>
            <div class="main" v-if="parent">
                <SmallTitle title='家庭基本信息'></SmallTitle>
                <ul>
                    <li>母亲姓名：{{parent.motherName}}</li>
                    <li style="width: 60%">联系方式：{{parent.motherPhone}}</li>
                    <li>父亲姓名：{{parent.fatherName}}</li>
                    <li style="width: 60%">联系方式：{{parent.fatherPhone}}</li>
                </ul>
            </div>

            <div class="main" v-if="hobbyPlan">
                <SmallTitle title='兴趣爱好与规划'></SmallTitle>
                <div class="hobby">
                    <p class="title" style="background-color: #1CA4B6;">兴趣爱好</p>
                    <p class="detail">{{hobbyPlan.myHobby}}</p>
                </div>
                <div class="hobby">
                    <p class="title" style="background-color: #FEAE3B;" >特长优势</p>
                    <p class="detail">{{hobbyPlan.mySpecialty}}</p>
                </div>
                <div class="hobby">
                    <p class="title" style="background-color: #AACF00;" >向往职业</p>
                    <p class="detail">{{hobbyPlan.myLikeCareer}}</p>
                </div>
                <div class="hobby">
                    <p class="title" style="background-color: #00B3F0;"> 向往专业</p>
                    <p class="detail">{{hobbyPlan.myLikeMajor}}</p>
                </div>
                <div class="hobby">
                    <p class="title" style="background-color: #FFDB1F;">向往大学</p>
                    <p class="detail">{{hobbyPlan.myLikeUniversity}}</p>
                </div>
            </div>
         </div>
    </div>
</template>
<script>
import BigTitle from './bigTitle'
import MiddleTitle from './middleTitle'
import SmallTitle from './smallTitle'
export default {
    name: "pageStudentMessage",
    props: ['baseInfoStudentCensus'],
    components: {
        BigTitle,MiddleTitle,SmallTitle
    },
    data() {
        return {
        }
    },
    computed: {
        student() {
            return this.baseInfoStudentCensus.student;
        },
        parent() {
            return this.baseInfoStudentCensus.parent;
        },
        hobbyPlan() {
            return this.baseInfoStudentCensus.hobbyPlan;
        }
    },
    methods: {
        switchTimeFormat(time) {
            let date = new Date(time);
            return date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate())
        },
        checkTime(i) {
            if (i < 10) {
                i = '0' + i
            }
            return i
        }
    },
}
</script>
<style scoped lang="less">
.pageStudentMessage {
    
}
</style>